import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import type { Modal as ModalType } from "../../redux/modals/modals.types";
import { selectorOpenModal } from "../../redux/modals/selectors";
import Modal from "./modal";
import * as CSS from "./modals.styles";

const ModalsWrapper = () => {
	const openModal = useSelector(selectorOpenModal);
	const [displayedModal, setDisplayedModal] = useState<ModalType | null>(null);
	const [visible, setVisible] = useState(false);

	// Mount/unmount displayedModal in sync with redux state, holding it around
	// for the exit transition instead of unmounting the instant openModal clears.
	useEffect(() => {
		if (openModal) {
			setDisplayedModal(openModal);
			return;
		}

		const timeout = setTimeout(() => setDisplayedModal(null), CSS.MODAL_TRANSITION_MS);
		return () => clearTimeout(timeout);
	}, [openModal]);

	// Only flip visible once displayedModal has actually mounted/updated and
	// been painted, so the enter transition has a real "before" frame to play from.
	useEffect(() => {
		if (!displayedModal) return;

		if (!openModal) {
			setVisible(false);
			return;
		}

		setVisible(false);
		const frame = requestAnimationFrame(() => setVisible(true));
		return () => cancelAnimationFrame(frame);
	}, [displayedModal, openModal]);

	if (!displayedModal) {
		return null;
	}

	return (
		<CSS.ModalsWrapper $visible={visible}>
			<Modal modal={displayedModal} visible={visible} />
		</CSS.ModalsWrapper>
	);
};

export default ModalsWrapper;
